"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'frontpage',
    name: 'Front Page',
    background_color: '#ffffff',
    background_image: null,
    background_image_portrait: null,
    heading_font: 'https://fonts.raydiant.com/Roboto-Light.woff',
    heading_text_color: '#1d94c6',
    heading_2_font: 'https://fonts.raydiant.com/Roboto-Medium.woff',
    heading_2_text_color: '#1d94c6',
    body_font: 'https://fonts.raydiant.com/Alice-Regular.woff',
    body_text_color: '#051727',
    border_color: '#333333',
};
//# sourceMappingURL=frontpage.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/frontpage.js